var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fade",attrs:{"id":"generatingModal","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._v("\n                "+_vm._s(_vm.$lang("Trwa generowanie pliku..."))+"\n            ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }